import { Injectable } from '@angular/core';
import { ISidebarState } from './model/sidebar-state.model';

@Injectable({
  providedIn: 'root',
})
export class RestoreSidebarStateService {
  private readonly updaters = new Set<(state: ISidebarState) => void>();

  registerUpdater(updater: (state: ISidebarState) => void): void {
    this.updaters.add(updater);
  }

  restoreState(state: ISidebarState): void {
    this.updaters.forEach((updater) => {
      updater.call(this, state);
    });
  }
}
